/**
 * Tipo de entrega do pedido, espelhando `TipoDeEntrega` do backend.
 *
 * Sao as tres modalidades que o cliente escolhe: consumir no local, levar embora ou receber em
 * casa. Ate a V1.113 o backend so tinha dois valores — consumo no local e retirada eram gravados
 * como `RETIRADA_NO_LOCAL` e so davam para ser separados adivinhando pela mesa preenchida.
 */
export enum TipoDeEntrega {
  /** Cliente leva o pedido embora ("Para llevar"). */
  RETIRADA_NO_LOCAL = 'RETIRADA_NO_LOCAL',
  /** Pedido sai para a rua: a unica modalidade com etapa de envio e com frete. */
  DELIVERY = 'DELIVERY',
  /** Cliente consome no estabelecimento, na mesa ou na comanda ("En el local"). */
  CONSUMO_NO_LOCAL = 'CONSUMO_NO_LOCAL',
}

/** Ícone e classe de cor do badge, por tipo. */
export const TIPO_ENTREGA_CONFIG: Record<TipoDeEntrega, { icone: string; classe: string }> = {
  [TipoDeEntrega.RETIRADA_NO_LOCAL]: { icone: 'pi pi-shopping-bag', classe: 'tipo-retirada' },
  [TipoDeEntrega.DELIVERY]: { icone: 'pi pi-send', classe: 'tipo-delivery' },
  [TipoDeEntrega.CONSUMO_NO_LOCAL]: { icone: 'pi pi-building', classe: 'tipo-local' },
};

/**
 * Le o campo `tipoEntrega` do pedido, que chega como string ou como objeto LocalizableEnum
 * (`{ enum, nome, id, descricao }`), dependendo do endpoint.
 */
export function resolverTipoEntrega(tipoEntrega: any): TipoDeEntrega | null {
  if (!tipoEntrega) return null;
  const valor = typeof tipoEntrega === 'string'
    ? tipoEntrega
    : (tipoEntrega.enum || tipoEntrega.name || '');
  return Object.values(TipoDeEntrega).includes(valor as TipoDeEntrega)
    ? (valor as TipoDeEntrega)
    : null;
}

/**
 * O cliente esta no estabelecimento, entao nao existe etapa de envio — vale para retirada e para
 * consumo no local. Espelha `TipoDeEntrega.ehNoEstabelecimento()` do backend: perguntar "nao e
 * delivery" evita que um tipo novo caia por engano na trilha de quem sai para a rua.
 */
export function ehNoEstabelecimento(tipoEntrega: any): boolean {
  const tipo = resolverTipoEntrega(tipoEntrega);
  return tipo !== null && tipo !== TipoDeEntrega.DELIVERY;
}
